import React from 'react';
import { connect } from 'react-redux';
import Chart from 'react-apexcharts';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import { withStyles } from '@mui/styles';

import { LoadingView } from './LoadingView';
import { TitleTooltip } from './TitleTooltip';

import {
  StoreUtil,
} from 'doctivity-shared/utils';

import {
  loadAnalytics,
} from 'store/actions/analyticsActions';
import { withIsMobile } from 'utils';

const styles = (theme) => ({
  card: {
    marginTop: theme.spacing(3),
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  leftIcon: {
    marginRight: theme.spacing(),
  },
  nothingFound: {
    fontWeight: 300,
    fontSize: 12,
  },
});

class ReferringAffiliationPieChart extends React.Component {
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.providerId !== prevProps.providerId
      || this.props.clientId !== prevProps.clientId
      || this.props.department !== prevProps.department
      || this.props.referringOrganization !== prevProps.referringOrganization
      || this.props.providerLabelId !== prevProps.providerLabelId
      || this.props.referrerLabelId !== prevProps.referrerLabelId
      || this.props.app.dateRange !== prevProps.app.dateRange) {
      this.fetchData();
    }
  }

  fetchData() {
    const {
      dispatch,
      providerId,
      clientId,
    } = this.props;

    dispatch(loadAnalytics({
      type: 'REFERRING_PROVIDER_AFFILIATION',
      filter: {
        department: this.props.department,
        referring_organization: this.props.referringOrganization,
        provider_tag_id: this.props.providerLabelId,
        referrer_tag_id: this.props.referrerLabelId,
        provider_id: providerId,
        client_id: clientId,
      },
      opts: {
        from: this.props.app.dateRange.start,
        to: this.props.app.dateRange.end,
      },
    }));
  }

  render() {
    const {
      classes,
      data,
      isMobile,
    } = this.props;

    let graph;
    if (!data
      || StoreUtil.isLoading(data)) {
      graph = (<LoadingView />);
    } else if (data && data.data && data.data.length > 0) {
      const rows = StoreUtil.getData(data);
      
      if (rows && rows.length > 0) {
        const affiliated = rows[0].total_affiliated || 0;
        const totalReferred = rows[0].total_referred || 0;
        const nonAffiliated = Math.max(0, totalReferred - affiliated);
        
        // Only render chart if there's actual data
        if (affiliated > 0 || nonAffiliated > 0) {
          const labels = [];
          const cleanData = [];
          
          if (affiliated > 0) {
            labels.push('Affiliated');
            cleanData.push(affiliated);
          }
          
          if (nonAffiliated > 0) {
            labels.push('Non-Affiliated');
            cleanData.push(nonAffiliated);
          }

          graph = (
            <Chart
              type='pie'
              {...(isMobile ? {} : {height: 210})}
              options={{
                ...(isMobile ? { legend: { horizontalAlign: 'left', position: 'bottom' } } : {}),
                chart: {
                  id: 'referring-affiliation-pie',
                },
                labels,
                dataLabels: {
                  enabled: true,
                },
                plotOptions: {
                  pie: {
                    expandOnClick: true,
                  },
                },
              }}
              series={cleanData}
            />
          );
        } else {
          graph = (
            <Typography className={classes.nothingFound}>
              No referring affiliation data available.
            </Typography>
          );
        }
      } else {
        graph = (
          <Typography className={classes.nothingFound}>
            No referring affiliation data available.
          </Typography>
        );
      }
    } else {
      graph = (
        <Typography className={classes.nothingFound}>
          No referring affiliation data available.
        </Typography>
      );
    }

    return (
      <Card className={classes.card}>
        <CardContent>
          <div className={classes.header}>
            <TitleTooltip
              title='Referring Affiliation'
              tooltip=''
            />
          </div>

          {graph}

        </CardContent>
      </Card>
    );
  }
}

ReferringAffiliationPieChart.propTypes = {
  dispatch: PropTypes.func.isRequired,
  classes: PropTypes.object,
  app: PropTypes.object,
  data: PropTypes.object,
  providerId: PropTypes.number,
  clientId: PropTypes.number.isRequired,
  department: PropTypes.string,
  referringOrganization: PropTypes.string,
  providerLabelId: PropTypes.number,
  referrerLabelId: PropTypes.number,
  isMobile: PropTypes.bool,
};

function mapStateToProps(state) {
  const {
    analytics,
    app,
  } = state;

  return {
    app,
    data: StoreUtil.get(analytics, 'REFERRING_PROVIDER_AFFILIATION'),
  };
}

const styled = withIsMobile(withStyles(styles)(ReferringAffiliationPieChart));
const connected = connect(mapStateToProps)(styled);
export { connected as ReferringAffiliationPieChart };